<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M15.1 16.44C14.79 20.04 12.94 21.51 8.88998 21.51H8.75998C4.28998 21.51 2.49998 19.72 2.49998 15.25L2.49998 8.73998C2.49998 4.26998 4.28998 2.47998 8.75998 2.47998H8.88998C12.91 2.47998 14.76 3.92998 15.09 7.46998"
    stroke="#CA2140"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M9 12L20.38 12"
    stroke="#CA2140"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M18.15 15.3499L21.5 11.9999L18.15 8.6499"
    stroke="#CA2140"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
